/**
 * Typed tenant notifications API facade over the generated contract client.
 */

import { z } from 'zod';
import { tenantNotificationsApi } from '../api/generated/tenantNotifications.api.js';
import { BillingNotificationResponseSchema } from '@cnapse/shared/schemas.js';

class TenantNotificationsService {
  async getSubscriptionNotification(): Promise<z.infer<typeof BillingNotificationResponseSchema>> {
    try {
      return (await tenantNotificationsApi.getSubscriptionStatus()) as z.infer<
        typeof BillingNotificationResponseSchema
      >;
    } catch (error) {
      // Silent fail for banner - don't disrupt user experience if notification fetch fails
      console.warn('Failed to get subscription notification:', error);
      return {
        show: false,
        severity: 'info' as const,
        message: '',
        daysRemaining: null,
      };
    }
  }
}

export const tenantNotificationsService = new TenantNotificationsService();
